import React, { Component } from 'react'
import { connectInfiniteHits } from 'react-instantsearch-dom'

class Hits extends Component {
  constructor(props){
    super(props)
  }

  createMarkup(value) {
    return { __html: value }
  }

  render() {
    const { hits, hasPrevious, refinePrevious, hasMore, refineNext } = this.props
    const pageList = hits.map((page) => {

      const pageUrl = `${window.location.origin}/pages/${page.handle}`

      return (
        <div className="wide margin-bottom-2x" key={page.objectID}>
          <div className="wide">
            <p className="text-large margin-bottom-1x">{page.title}</p>
            <p className="text-medium foreground-dark-green" dangerouslySetInnerHTML={this.createMarkup(page.content)} />
            <a className="foreground-blue text-medium" href={`pages/${page.handle}`}>{pageUrl}</a>
          </div>
        </div>
      )
    })

    return (
      <React.Fragment>
        <div className="margin-6x">
          {pageList}
        </div>
        {hasMore ? (
          <div className="row flex h-center padding-top-3x padding-bottom-5x small-padding-top-4x small-margin-0x">
            <div className="column column-6 small-12 small-padding-0x text-center">
              <button className="button is-border is-small wide" onClick={refineNext}>
                Load more
              </button>
            </div>
          </div>
        ) : null}
      </React.Fragment>
    )
  }
}

const PageHits = connectInfiniteHits(Hits)

export default PageHits
